import { useState } from 'react'

import cn from 'clsx'

import { ArrowRight } from '@App/static/icons/AccountOrdersPageIcons'

import OutsideClickComponent from '../../../OutsideClickHandler'

import s from './AccountOptions.module.scss'
import { AccountOptions } from './components/AccountOptions'

export const AccountOptionsButton = () => {
  const [isOpenOptions, setIsOpenOptions] = useState(false)

  return (
    <OutsideClickComponent
      className={cn(s.container, isOpenOptions && s.active)}
      onClick={() => setIsOpenOptions(!isOpenOptions)}
      handler={() => setIsOpenOptions(false)}
    >
      <div className={s.account}>Demo</div>

      <div className={s.iconContainer}>
        <ArrowRight className={s.icon} />
        {isOpenOptions && (
          <div className={s.optionsContainer}>
            <AccountOptions />
          </div>
        )}
      </div>
    </OutsideClickComponent>
  )
}
